import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setPageTitle } from 'actions/header';
import { getConversation, submitMessage, createConversation, resetConversation, submitConversationFile } from 'actions/conversation';
import { getConversationParticipants } from '../Helpers';
import ConversationHeader from './ConversationHeader';
import ConversationMessages from './ConversationMessages';
import MessageForm from '../Form/MessageForm';
import { translate } from '@haldor/ui';
var ConversationPage = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function ConversationPage(props) {
    var _this;
    _classCallCheck(this, ConversationPage);
    _this = _callSuper(this, ConversationPage, [props]);
    /* Lifecycle methods */
    _defineProperty(_this, "componentDidMount", function () {
      var id = _this.props.match.params.id;
      if (id != 'new') {
        _this.props.getConversation(id).then(function () {
          _this.setTitle();
          _this.setState({
            loading: false
          });
        });
      } else {
        if (_this.props.staged == null) {
          _this.props.history.replace("/conversations");
        } else {
          _this.setTitle();
          _this.setState({
            loading: false
          });
        }
      }
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var id = nextProps.match.params.id;
      if (id != _this.props.match.params.id) {
        _this.setState({
          loading: true
        });
        _this.props.getConversation(id).then(function () {
          _this.setTitle();
          _this.setState({
            loading: false
          });
        });
      }
    });
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      var prevMemberships = prevProps.conversation != null ? prevProps.conversation.memberships : null;
      var currMemberships = _this.props.conversation != null ? _this.props.conversation.memberships : null;
      if (currMemberships != null && prevMemberships != null && currMemberships !== prevMemberships) {
        _this.setTitle();
      }
    });
    _defineProperty(_this, "setTitle", function () {
      var user = _this.props.user;
      var id = _this.props.match.params.id;
      var members = null;
      if (id != 'new') {
        members = getConversationParticipants(_this.props.conversation, user);
      } else {
        members = getConversationParticipants(_this.props.staged, user);
      }
      if (members == null) {
        return null;
      }
      var title = '';
      members.forEach(function (member, index) {
        if (member != null) {
          if (index > 0) {
            title += ', ';
          }
          if (member.membershipType == 'SECTION_OWNERS') {
            title += member.title + " (" + _this.props.translate('Staff') + ")";
            return true;
          }
          if (member.membershipType == 'GUARDIAN') {
            member.lastName = (member.lastName != null ? member.lastName : '') + ' (' + _this.props.translate('guardian') + ')';
          }
          title += member.firstName + ' ' + member.lastName;
        }
      });
      _this.props.setPageTitle(title);
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.onResize);
      _this.props.resetConversation();
    });
    /* Events */
    _defineProperty(_this, "submitMessage", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, file) {
        var hasText, messageValues, conversation, lastMessage, currentUser, newConversation, conversationId;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              hasText = values != null && typeof values.text === 'string' && values.text.trim() !== '';
              if (!(!hasText && file == null)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", 1);
            case 1:
              messageValues = values != null ? _objectSpread({}, values) : null;
              conversation = _this.props.conversation;
              if (_this.props.match.params.id == 'new') {
                conversation = _this.props.staged;
              }
              if (hasText) {
                if (_this.props.conversation != null) {
                  lastMessage = _this.props.conversation.messages[_this.props.conversation.messages.length - 1];
                  if (lastMessage == null) {
                    messageValues.parentId = null;
                  } else {
                    messageValues.parentId = lastMessage.id;
                  }
                } else {
                  messageValues.parentId = null;
                }
                currentUser = _this.props.user;
                messageValues.creator = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
                messageValues.senderId = messageValues.creator;
                messageValues.senderType = 'USER';
              }
              if (!(_this.props.match.params.id == 'new')) {
                _context.next = 5;
                break;
              }
              newConversation = _objectSpread(_objectSpread({}, _this.props.staged), {}, {
                messages: hasText ? [messageValues] : []
              });
              if (messageValues != null) {
                delete messageValues.conversationID;
              }
              _this.setState({
                loading: true
              });
              _context.next = 2;
              return _this.props.createConversation(newConversation);
            case 2:
              conversationId = _context.sent;
              _this.props.history.replace("/conversations/".concat(conversationId));
              if (!(file != null)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this.props.submitConversationFile(conversationId, file);
            case 3:
              _context.next = 4;
              return _this.props.getConversation(conversationId);
            case 4:
              _this.setTitle();
              _this.setState({
                loading: false
              });
              return _context.abrupt("return", 1);
            case 5:
              if (!hasText) {
                _context.next = 6;
                break;
              }
              _context.next = 6;
              return _this.props.submitMessage(messageValues);
            case 6:
              if (!(file != null)) {
                _context.next = 9;
                break;
              }
              _context.next = 7;
              return _this.props.submitConversationFile(conversation.id, file);
            case 7:
              _context.next = 8;
              return _this.props.getConversation(conversation.id);
            case 8:
              _context.next = 10;
              break;
            case 9:
              if (hasText) {
                _this.setState({});
              }
            case 10:
              return _context.abrupt("return", 1);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "uploadFile", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
        var _conversation, newId, conversation;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this.props.match.params.id == 'new')) {
                _context2.next = 3;
                break;
              }
              _conversation = _objectSpread({}, _this.props.staged);
              _conversation.messages = [];
              _this.setState({
                loading: true
              });
              _context2.next = 1;
              return _this.props.createConversation(_conversation);
            case 1:
              newId = _this.props["new"];
              _this.props.history.replace("/conversations/".concat(newId));
              _context2.next = 2;
              return _this.props.getConversation(newId);
            case 2:
              _this.setTitle();
              _this.setState({
                loading: false
              });
            case 3:
              conversation = _this.props.conversation;
              if (!(conversation == null || conversation.id == null)) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", Promise.reject());
            case 4:
              _context2.next = 5;
              return _this.props.submitConversationFile(conversation.id, file);
            case 5:
              _context2.next = 6;
              return _this.props.getConversation(conversation.id);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onResize", function () {
      var messages = document.querySelector('.conversation--wrapper');
      if (messages != null) {
        var height = 0;
        var body = document.querySelector('body');
        var footer = body.querySelector('.site-footer');
        var header = body.querySelector('.teams-header');
        var desktopHeader = body.querySelector('.desktop-header-spacing');
        var deviceMenu = body.querySelector('.footer-menu-bar-container');
        var deviceHeader = body.querySelector('.device-menu');
        height = window.innerHeight;
        if (footer != null) {
          height = height - footer.scrollHeight;
        }
        if (header != null) {
          height = height - header.scrollHeight;
        }
        if (desktopHeader != null) {
          height = height - desktopHeader.scrollHeight;
        }
        if (deviceMenu != null) {
          height = height - deviceMenu.scrollHeight - 15;
        }
        if (deviceHeader != null) {
          height = height - deviceHeader.scrollHeight;
        }
        messages.style.height = height - 25 + 'px';
      }
    });
    _this.state = {
      loading: true
    };
    return _this;
  }
  _inherits(ConversationPage, _Component);
  return _createClass(ConversationPage, [{
    key: "render",
    value: /* Render methods */
    function render() {
      var conversation = this.props.conversation;
      var disabled = false;
      if (this.props.match.params.id == 'new') {
        conversation = this.props.staged;
      }
      if (conversation != null && conversation.status == 'ARCHIVED') {
        disabled = true;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "conversation conversation--wrapper"
      }, /*#__PURE__*/React.createElement(ConversationHeader, {
        conversation: conversation
      }), /*#__PURE__*/React.createElement(ConversationMessages, {
        conversation: conversation
      }), /*#__PURE__*/React.createElement(MessageForm, {
        onSubmit: this.submitMessage,
        conversation: conversation,
        disabled: disabled,
        handleFiles: true
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    conversation: state.Conversation.conversation,
    staged: state.Conversation.staged,
    "new": state.Conversation["new"],
    activeStudent: state.User.activeStudent,
    user: state.User.user,
    translate: translate(state.Languages.translations)
  };
}
export default withRouter(connect(mapStateToProps, {
  getConversation: getConversation,
  submitMessage: submitMessage,
  submitConversationFile: submitConversationFile,
  createConversation: createConversation,
  setPageTitle: setPageTitle,
  resetConversation: resetConversation
})(ConversationPage));